import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ApiBusinessRulesService} from "./api-business-rules.service";

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [ApiBusinessRulesService]
})
export class ApiBusinessRulesModule { }
